import {
  Lightning, ChartLineUp, Waveform, ShieldCheckered,
  Clock, Newspaper, Pulse, Cube, Target,
} from "@phosphor-icons/react";

/** Static config — extracted out of components to avoid recreating on every render. */

export const ENGINES = [
  { id: "smc",        name: "SMC",         tag: "Smart Money",       Icon: Cube },
  { id: "ict",        name: "ICT",         tag: "Kill Zones",        Icon: Clock },
  { id: "order_flow", name: "Order Flow",  tag: "Aggression Δ",      Icon: Waveform },
  { id: "liquidity",  name: "Liquidity",   tag: "Pools & Sweeps",    Icon: Target },
  { id: "session",    name: "Session",     tag: "Asia · LDN · NY",   Icon: ChartLineUp },
  { id: "news",       name: "News Risk",   tag: "Red Folder",        Icon: Newspaper },
  { id: "volatility", name: "Volatility",  tag: "ATR Adaptive",      Icon: Pulse },
  { id: "momentum",   name: "Momentum",    tag: "MTF Trend",         Icon: Lightning },
  { id: "risk",       name: "Risk",        tag: "Auto-Downgrade",    Icon: ShieldCheckered },
];

export const MOTION_HERO_IN = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: "easeOut" },
};

export const MOTION_TILE_IN_VIEW = {
  initial: { opacity: 0, y: 10 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
};

export const MOTION_FADE_UP = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
};

/** Loading skeleton — stable keys (avoid array-index keys). */
export const SKELETON_KEYS = ["sk1", "sk2", "sk3", "sk4", "sk5", "sk6"];
